// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__g1sg6","colCheckbox":"styles_colCheckbox__2FyVp"};